import {Inject, Injectable} from "@angular/core";
import {DOCUMENT} from "@angular/common";
import {UFAppEnvironmentContext, UFWindow} from "../Models/UFAppEnvironmentModels";
import {AppSettings} from "../Library/AppSettings";

@Injectable()
export class UFBootstrapService {
    private window: UFWindow;
    constructor(@Inject(DOCUMENT) private readonly document: Document) {
        this.window = this.document.defaultView as UFWindow;
    }

    bootstrapApplicationEnvironment(): Promise<void> {
        if (!this.window.unifocus) {
            return Promise.resolve()
        }

        return new Promise(
            (resolve) =>
                this.window.unifocus.initializeEnvironment(
                    () => {
                        resolve();
                    }
                )
        );
    }

    userLogout() {
        this.window.unifocus && this.window.unifocus.signOut();
    }

    isRunningInIframe() : boolean {
        return this.window.location !== this.window.parent.location;
     }

    isRunningInSingularity(): boolean {
        return this.window.name === 'singularity-iframe';
    }

}
